<div class="flex flex-col">
  <div class="pt-8 pl-72 pr-72 pb-8">
    <app-breadcrumb [items]="breadcrumbItems" class="breadcrumb"></app-breadcrumb>
  </div>
  <div class="flex flex-row justify-between header-background-color header">
    <div class="flex flex-row flex-auto pl-72 pt-12 pr-72 pb-20">
      <div class="flex flex-row pt-6">
        <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0"
            [routerLink]="['/', authService.principal.provider, RouterSegments.TENANT, tenantId, RouterSegments.SERVICE_DEFINITION, blueprintId]"></mat-icon>
      </div>
      <div class="flex flex-col flex-auto justify-between pl-24">
        <div class="flex flex-row justify-between mb-12 instance-name">
          <div class="mat-subtitle-1 fw-600 fs-32 mb-0">{{'INSTANCE_DETAILS.UPDATE_MENU.UPDATE_SERVICE_DEFINITION' | transloco}}</div>
        </div>
         <div class="flex flex-row mt-12 header-meta">
          <div class="mr-12">
            {{ 'INSTANCE_DETAILS.SERVICE_DEFINITION' | transloco }}:
            <span *ngIf="!isLoading else loader">{{ blueprint?.name }}</span>
          </div>
          <span class="vertical-divider" [class.loading-divider]="isLoading"></span>
          <div class="pl-12 mr-12">
            {{'BLUEPRINT_SUMMARY.SUMMARY.ENVIRONMENT' | transloco}}
            <span>{{ instance?.name }}</span>
          </div>
          <span class="vertical-divider" [class.loading-divider]="isLoading"></span>
          <div class="pl-12">
            {{'SIZING.SIZING' | transloco}}
            <span>{{'SIZING.SIZE' | transloco}}</span>
          </div>
        </div>
        <ng-template #loader>
            <span class="skeleton-loader">
              <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '22px', width: '120px' }"></ngx-skeleton-loader>
            </span>
        </ng-template>
        <ng-template #headerLoader>
          <div class="pl-6 skeleton-loader-header">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Stepper -->
  <div class="deploy-stepper-row ml-72 mr-72">
    <div class="step-card">
      <app-service-definition-step
        [active]="isActive('serviceDefinition')"
        [completed]="isCompleted('serviceDefinition')"
        [version]="selection?.version">
      </app-service-definition-step>
    </div>
    <span class="step-arrow">
      <mat-icon svgIcon="double_right_arrow"></mat-icon>
    </span>
    <div class="step-card">
      <app-sizing
        [active]="isActive('sizing')"
        [completed]="isCompleted('sizing')"
        [failed]="isFailed('sizing')"
        [sizingStatus]="sizingStatus"
        [createdDate]="sizingCreatedDate"
        [createdBy]="sizingCreatedBy">
      </app-sizing>
    </div>
  </div>

  <!-- Sizing Document Banner -->
  <div *ngIf="sizingStatus === SizingStatus.COMPLETED && currentStep === 'sizing' && sizingDocumentId" class="ml-72 mr-72 mb-24 sizing-doc-banner">
    <span class="label">Name: {{ sizingDocumentName }}</span>
            <span class="separator">|</span>
            <span class="label">Created: {{ sizingCreatedDate | date : 'MMM dd, yyyy' }}</span>
            <span class="separator">|</span>
            <mat-icon class="account-circle" svgIcon="account_circle_filled" matTooltipClass="tooltip-inner right" [matTooltip]="sizingCreatedBy" [matTooltipPosition]="'right'"></mat-icon>
  </div>

  <!-- Service Definition Step Content -->
  <div class="ml-72 mr-72 border-table" *ngIf="currentStep === 'serviceDefinition'">
  <div class="flex flex-col m-12">
    <!-- Header with title and paginator -->
    <div class="flex items-center justify-between p-16">
      <div class="flex items-center">
        <div class="mat-subtitle-2 mb-0 fs-20 fw-600">
          {{'TENANT_DASHBOARD.CHOOSE_SERVICE_DEFINITION' | transloco }}
        </div>
      </div>
      <div class="flex flex-row gap-3" *ngIf="!dataLoading && showTable && tableData?.length > 0">
        <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer"
             (click)="refreshData()">
          <mat-icon svgIcon="refresh"
                    class="icons transition-transform duration-700"
                    [ngClass]="{ 'animate-spin': dataLoading }">
          </mat-icon>
        </div>
        <app-environment-paginator
          class="envt-paginator"
          [length]="filteredConfigurations?.length || tableData?.length"
          [pageSize]="paginationSize"
          [pageIndex]="pageIndex"
          (page)="pageChanged($event)">
        </app-environment-paginator>
      </div>
    </div>

    <!-- Table section -->
    <div class="flex flex-col p-16 height-table">
      <app-environment-table
        *ngIf="showTable"
        [showStageInfoIcon]="false"
        [initialDataSource]="paginatedTableData"
        [displayColumns]="displayColumns"
        [showSkeletonLoader]="dataLoading"
        [dataLoading]="dataLoading"
        [dataSourceLength]="true"
        [initialCreate]="tableData?.length === 0"
        [instance]="instance"
        (approve)="select($event)"
        (versionClick)="onVersionClick($event)"
        pageName="updateServiceDefinition">
      </app-environment-table>
    </div>
  </div>
  </div>

  <!-- Sizing Step Content -->
  <div class="ml-72 mr-72" *ngIf="currentStep === 'sizing'">
    <app-sizing-content
      [sizingCards]="sizingCards"
      [currentView]="currentView"
      [searchTerm]="sizingSearchTerm"
      [isJsonLoading]="isJsonLoading"
      [jsonInput]="jsonInput"
      [editorOptions]="editorOptions"
      (viewChanged)="switchView($event)"
      (searchChanged)="onSearchChanged($event)"
      (downloadRequested)="downloadJson()" [templateResponse] ="templateResponse" [componentError]="errorsWithComponent" (viewErrorDetails)="showErrorDialog(false)" [retrySizing]="retrySizing">
    </app-sizing-content>
  </div>

  <mat-divider *ngIf="!isGlobalLoading" class="mt-32 mb-32 neutral-2"></mat-divider>

  <div *ngIf="!isGlobalLoading" class="flex flex-row justify-end ml-72 mr-72 mb-24">
    <div>
      <button class="white mr-16" type="button" (click)="goBack()">
        {{ 'BUTTONS.CANCEL' | transloco }}
      </button>
    </div>
    <div class="flex flex-row gap-3">
      <button class="accent" type="button" *ngIf="currentStep === 'serviceDefinition'"
              [ngClass]="{'disabled': !selection}" [disabled]="!selection"
              (click)="nextStep()">
        {{ 'BUTTONS.NEXT' | transloco }}
      </button>
      <button class="accent" type="button" *ngIf="currentStep === 'sizing' && !sizingDocumentId" [ngClass]="{'disable-btn ': !validSchema}"
              (click)="validSchema ? applyConfiguration() : ''">
        {{ 'BUTTONS.SUBMIT' | transloco }}
      </button>
      <button class="accent" type="button" *ngIf="currentStep === 'sizing' && sizingDocumentId" [ngClass]="{'disable-btn ': !validSchema}"
              (click)="validSchema ? applyServiceDefinition() : ''">
        {{ 'BUTTONS.SUBMIT' | transloco }}
      </button>
    </div>
  </div>
</div>
